import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';

export default function Invitation_logs() {
    const [logs, setLogs] = useState([])
    const [campaigns, setCampaigns] = useState([]);
    const [alertMsg, setAlertMsg] = useState("");
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [campaignDetails, setCampaignDetails] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {

        let company_id = localStorage.getItem('mem_company_id');

        fetch("get_invitation_logs.php", {
            method: 'POST',
            body: new URLSearchParams({
                company_id: company_id
            })
        })

            .then(res => res.json())
            .then(data => setLogs(data))

    }, [])

    useEffect(() => {

        let company_id = localStorage.getItem('mem_company_id');

        fetch("get_campaign_logs.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ company_id })
        })
            .then(res => res.json())
            .then(data => setCampaigns(data));

    }, []);

    const viewCampaign = (id) => {

        fetch("get_campaign_details.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ campaign_id: id })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data); // show in modal later
                setCampaignDetails(data); // store data
                setShowModal(true);
            });
    };

    const closeModal = () => {
        setShowModal(false);
        setCampaignDetails(null);
    };

    const resendCampaign = (id) => {
        document.getElementById('waitloader').style.display = 'block';
        document.getElementById('waitloaderinner').style.display = 'block';
        fetch("resend_campaign.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ campaign_id: id })
        })
            .then(res => res.json())
            .then(res => {
                document.getElementById('waitloader').style.display = 'none';
                document.getElementById('waitloaderinner').style.display = 'none';
                showAlert("Campaign resent successfully");
            });

    };

    const showAlert = (msg) => {
        setAlertMsg(msg);
        setShowAlertBox(true);
    };

    const closeAlert = () => {
        setShowAlertBox(false);
        setAlertMsg("");
        localStorage.setItem('communications', 'log');
        navigate('/redirect_communications');
    };

    function loadCampaingsLog() {
        document.getElementById('camp_log').style.display = 'block';
    }

    function closecamplog() {
        document.getElementById('camp_log').style.display = 'none';
    }


    return (
        <div>
            <h2 className='innerpage_heading halfwidth'>Invitation/Campaign Logs</h2>
            <button className='borderbutton pull_right' onClick={loadCampaingsLog}>Campaign Log</button>
            <div className="vl_dsh_formnholder details_section">

                <h3 className="sectionlabel">Invitation Logs</h3>
                <div className='vl_dsh_one_table'>

                    <table className="template_table">

                        <thead>

                            <tr>
                                <th>Recipient</th>
                                <th>Email</th>
                                <th>Title</th>
                                <th>Status</th>
                                <th>Sent</th>
                               
                            </tr>

                        </thead>

                        <tbody>

                            {logs.map(log => (

                                <tr key={log.id}>

                                    <td>{log.recipient_name}</td>
                                    <td>{log.recipient_email}</td>
                                    <td>{log.title}</td>

                                    <td>
                                        {log.mail_status === "opened"
                                            ? <span className="green_text">Opened</span>
                                            : <span className="orange_text">Sent</span>}
                                    </td>

                                    <td>{log.sent_at}</td>                                  

                                </tr>

                            ))}

                        </tbody>

                    </table>
                </div>
            </div>
            <div className='camp_log_pop' id="camp_log">
                <div className='camp_log_container'>
                    <div className='closebtnholder'>
                        <button className='closeBtn' onClick={closecamplog}>+</button>
                    </div>
                    <div className="vl_dsh_formnholder details_section">
                        <h3 className="sectionlabel">Campaign Logs</h3>
                        <div className='vl_dsh_one_table'>
                            <table className="template_table">
                                <thead>
                                    <tr>
                                        <th>Campaign</th>
                                        <th>Subject</th>
                                        <th>Total</th>
                                        <th>Sent</th>
                                        <th>Opened</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {campaigns.map(c => (
                                        <tr key={c.id}>

                                            <td>{c.campaign_name}</td>
                                            <td>{c.subject}</td>
                                            <td>{c.total_recipients}</td>
                                            <td>{c.sent_count}</td>
                                            <td>{c.opened_count}</td>
                                            <td>{c.created_at}</td>

                                            <td>
                                                <button onClick={() => viewCampaign(c.id)} className='viewBTn'><i class="ri-eye-fill"></i> View</button>
                                                <button onClick={() => resendCampaign(c.id)} className='resendBtn'><i class="ri-mail-send-line"></i> Resend</button>
                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {showAlertBox && (
                <div className='vl_dsh_popup_vis'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>
                        <div className='contentarea'>
                            <p>{alertMsg}</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={closeAlert}>Okay</button>
                        </div>
                    </div>
                </div>
            )}
            <div className='loaderpop' id='waitloader'>
                <div className='loader_inner' id="waitloaderinner">
                    <p id="loadtext"></p>
                </div>
            </div>

            {showModal && campaignDetails && (
                <div className="modal_overlay">
                    <div className="modal_box">

                        <h3>Campaign Details</h3>

                        <p><b>Name:</b> {campaignDetails.campaign.campaign_name}</p>
                        <p><b>Subject:</b> {campaignDetails.campaign.subject}</p>
                        <p><b>Status:</b> {campaignDetails.campaign.status}</p>
                        <p><b>Created At:</b> {campaignDetails.campaign.created_at}</p>

                        <hr />

                        <h4>Recipients</h4>

                        {campaignDetails.recipients.map((r, index) => (
                            <div key={index} className="recipient_row">
                                <p><b>Name:</b> {r.recipient_name}</p>
                                <p><b>Email:</b> {r.recipient_email}</p>
                                <p><b>Status:</b> {r.status}</p>
                            </div>
                        ))}

                        <button onClick={closeModal} className='editbtn'>Close</button>

                    </div>
                </div>
            )}
        </div>
    )
}
